module.exports = function(data) {
var __t, __p = '';
__p += '<div class="operator-toggle">\n    <header>' +
((__t = ( data.typeAlias )) == null ? '' : __t) +
'</header>\n    <div class="btns">\n        <div class="btn left">+Include</div>\n        <div class="btn right">-Exclude</div>\n    </div>\n</div>\n<div>\n    <div>SWAP FILTER VALUE</div>\n    <div class="dd"></div>\n</div>';
return __p
}